import { useForm } from '@conform-to/react';
import { getFieldsetConstraint, parse } from '@conform-to/zod';
import { type ActionFunctionArgs, json } from '@remix-run/node';
import { Form } from '@remix-run/react';
import { z } from 'zod';

import { MultipleFileUploadField } from '../../components/forms.tsx';
import { persistTemporaryFile } from '../../models/AssetModel.js';

export const FileUploadSchema = z.object({
	files: z.array(z.string()).max(5),
});

export async function action({ request }: ActionFunctionArgs) {
	const formData = await request.formData();
	const submission = parse(formData, {
		schema: FileUploadSchema,
	});

	if (!submission.value) {
		return json(
			{
				status: 'error',
				submission,
			} as const,
			{ status: 400 },
		);
	}

	const { files } = submission.value;
	await Promise.all(
		files.map(fileId => {
			return persistTemporaryFile(fileId);
		}),
	);
	return json(
		{
			status: 'success',
			submission,
		} as const,
		{ status: 200 },
	);
}

export default function FileUploadDemo() {
	// useActionData<typeof action>()
	const [form, fields] = useForm({
		id: 'file-upload-demo',
		constraint: getFieldsetConstraint(FileUploadSchema),
		// lastSubmission: bargainEditorFetcher.data?.submission,
		onValidate({ formData }) {
			return parse(formData, { schema: FileUploadSchema });
		},
		defaultValue: {
			files: [],
		},
		shouldRevalidate: 'onBlur',
	});

	return (
		<main className="relative min-h-screen sm:flex sm:items-center sm:justify-center">
			<div className="relative sm:pb-16 sm:pt-8">
				<div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
					<Form
						method="post"
						className="flex h-full min-w-[368px] max-w-xl flex-col gap-1"
						{...form.props}
					>
						<MultipleFileUploadField
							label={'Upload your files'}
							field={fields.files}
							acceptedFileTypes={['application/pdf']}
							maxFiles={5}
						/>
						<button type="submit">Formular absenden</button>
					</Form>
				</div>
			</div>
		</main>
	);
}
